<template>
  <!-- 边框线-四个角-->
  <div class="main-box">
    <div class="main-box-div main-box-leftTop"></div>
    <div class="main-box-div main-box-rightBottom"></div>
    <div class="main-box-div main-box-leftBottom"></div>
    <div class="main-box-div main-box-rightTop"></div>
    <div class="div-border"></div>
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  name: "BorderCorner",
  data() {
    return {}
  }
}
</script>

<style scoped>
/*div四个角*/
.main-box {
  height: 100%;
  width: 100%;
  background-image: url("../../assets/images/leftTop.png"),
  url("../../assets/images/rightTop.png"),
  url("../../assets/images/leftBottom.png"),
  url("../../assets/images/rightBottom.png");
  background-repeat: no-repeat, no-repeat, no-repeat, no-repeat;
  background-position: top left, top right, bottom left, bottom right;
  position: relative;
  /*padding: 2px 2px 2px 2px; //设置padding给div往里挤*/
}

.main-box-div {
  display: inline-block;
  position: absolute; /*让里面的两个子容器绝对定位*/
  width: 40px;
  height: 40px;
}

.main-box-leftTop {
  top: 0;
  left: 0;
  background: linear-gradient(135deg, transparent 49.5%, rgba(1,239,253,.6) 49.5%, rgba(1,239,253,.6) 50.5%, transparent 52%);
  border-top: 1px solid #001a31;
  border-left: 1px solid #001a31;
}

.main-box-rightBottom {
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, transparent 49.5%, rgba(1,239,253,.6) 49.5%, rgba(1,239,253,.6) 50.5%, transparent 52%);
  border-right: 1px solid #001a31;
  border-bottom: 1px solid #001a31;
}

.main-box-leftBottom {
  bottom: 0;
  left: 0;
  background: linear-gradient(45deg, transparent 49.5%, rgba(1,239,253,.6) 49.5%, rgba(1,239,253,.6) 50.5%, transparent 52%);
  border-bottom: 1px solid #001a31;
  border-left: 1px solid #001a31;
}

.main-box-rightTop {
  right: 0;
  top: 0;
  background: linear-gradient(45deg, transparent 49.5%, rgba(1,239,253,.6) 49.5%, rgba(1,239,253,.6) 50.5%, transparent 52%);
  border-top: 1px solid #001a31;
  border-right: 1px solid #001a31;
}
.div-border {
  position: absolute;
  width: 100%;
  height: 25%;
  top: 35%;
  left: 0;
  border-left: 5px solid rgba(1, 239, 253, .5);
  border-right: 5px solid rgba(1, 239, 253, .5);
}
</style>
